export default __webpack_public_path__ + "static/media/sucess_toast_icon.7c41a855.svg";